module.exports = __webpack_public_path__ + "static/media/salt.da6c40f1.png";